var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfflineTimeWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#DE2C3C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.113 5.258.007 3.258.213.036c.255.042.583.147.793.252.084.042.159.076.167.076.007 0 .014-1.548.014-3.44V2h-1.201l.007 3.258m-3.206 2.32c0 1.41.004 2.559.01 2.553.006-.006.075-.107.153-.224.181-.271.533-.627.817-.824l.22-.154V5.013h-1.2v2.565M5.707 11v3h1.2V8h-1.2v3m5.583-1.959a2.786 2.786 0 0 0-1.985 1.479c-.2.407-.267.673-.284 1.121-.016.399.018.649.13.986.399 1.195 1.623 1.988 2.857 1.852a2.701 2.701 0 0 0 1.652-.768 2.74 2.74 0 0 0 .107-3.82 2.764 2.764 0 0 0-1.354-.803c-.24-.063-.882-.09-1.123-.047M2.507 12v2h1.2v-4h-1.2v2m9.706-.747v1.254h-.72V10h.72v1.253m-.152 1.805c.23.117.24.557.017.677-.192.102-.383.077-.52-.069-.316-.334.087-.821.503-.608m-3.154.616V14h.486l-.119-.14a4.391 4.391 0 0 1-.243-.326l-.124-.187v.327",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineTimeWarning);
export default __webpack_public_path__ + "static/media/offline-time-warning.af168317954b67e55074ce62c5bbc146.svg";
export { ForwardRef as ReactComponent };